import React, { useState, useEffect } from "react";
import { IoLocationSharp } from "react-icons/io5";
import { CgMail, CgProfile } from "react-icons/cg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Contacts from "@/pages/contacts";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

const testimonials = [
  {
    image: "/elaf-global-nobacground.jpg",
    text: "'Exim world has been a game-changer for our import/export business. Their expertise in connecting us with reliable suppliers and buyers worldwide has increased our revenue by 30%. Their team's knowledge and support have been invaluable.'",
    author: "- Bizanjo Khuda Dad (Director)",
    title: " Elaf Global",
  },
  {
    image: "/osg.png",
    text: "'As a new player in the import/export market, we needed guidance on navigating the complex global trade landscape. Exim world team provided us with invaluable insights and support, helping us establish a strong foothold in the market.'",
    author: " Omkar Gagare (Owner)",
    title: "- OSG International",
  },
  {
    image: "/rubbex.png",
    text: "'Exim world resource augmentation services have been a lifesaver for our company. Their team of experts has helped us streamline our import/export operations, reducing costs and increasing efficiency. We couldn't be happier with the results.'",
    author: "- Vinod Kumar Rajput (Director)",
    title: " Rubbex Conveyors",
  },
  {
    image: "/rbkInternational.png",
    text: "'Exim world monthly operational charges are a fraction of what we used to pay for similar services. Their team's expertise and efficiency have saved us thousands of dollars, allowing us to reinvest in our business and drive growth.'",
    author: "- Raviraj Kharmale (Owner)",
    title: " Rbk International",
  },
  {
    image: "/ARB-LOGO.png",
    text: "'We were struggling to find the right investors for our import/export venture. Exim world network and expertise helped us secure funding from a reputable investor. Their professionalism and dedication are unmatched.'",
    author: "- Abasaheb Banger (Director)",
    title: " ARB Impex",
  },
];

const Visaworldlandingpage = () => {
  const [formData, setFormData] = useState({
    Name: "",
    phone: "",
    email: "",
    companyName: "",
    message: "",
    Services: [],
  });

  const [showAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const ServicesList = [
    "Inward Payments",
    "Outward Payments",
    "Supply Chain Funding",
    "Co-lending Platform",
    "Payment Gateway",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleServicesChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      Services: checked
        ? [...prevState.Services, value]
        : prevState.Services.filter((service) => service !== value),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate at least one service is selected
    if (formData.Services.length === 0) {
      setErrorMessage("Please select  service.");
      return;
    }

    // Clear error message
    setErrorMessage("");

    // Format services for email
    const formattedServices = formData.Services.join(", ");

    const data = new FormData();
    data.append("name", formData.Name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("company", formData.companyName);
    data.append("services", formattedServices);
    data.append("message", formData.message);

    fetch(" ", {
      method: "POST",
      body: data,
    })
      .then((response) => response.text())
      .then((result) => {
        setAlertMessage(
          "Thank you for submitting the form. We will get back to you shortly!",
        );
        console.log(result);
        setShowAlert(true);
        setFormData({
          Name: "",
          phone: "",
          email: "",
          Services: [],
          message: "",
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const closeAlert = () => {
    setShowAlert(false);
  };

  const [activeSection, setActiveSection] = useState("");
  const handleScroll = () => {
    const sections = document.querySelectorAll("section");
    let scrollPosition = window.scrollY + 150; // Adjust offset for header height

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const sectionId = section.getAttribute("id");

      if (
        scrollPosition >= sectionTop &&
        scrollPosition < sectionTop + sectionHeight
      ) {
        setActiveSection(sectionId);
      }
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 70, // Adjust for header height
        behavior: "smooth",
      });
    }
  };

  const sliderRef = React.useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    pauseOnHover: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    appendDots: (dots) => (
      <div>
        <style jsx>{`
          ul {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          li {
            margin: 0 1rem;
          }

          .slick-active h2 {
            background-color: #2b6cb0;
          }

          h2 {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 1rem; /* This ensures some space between the dots */
          }
        `}</style>
        <ul>
          {dots.slice(0, 5).map((dot, index) => (
            <h2
              key={index}
              className={`h-4 w-4 rounded-full ${
                dot.props.className.includes("slick-active")
                  ? "bg-[#FF8064]"
                  : "bg-black"
              }`}
            >
              {dot}
            </h2>
          ))}
        </ul>
      </div>
    ),
    customPaging: () => <div className="h-3 w-3 rounded-full "></div>,
  };
  return (
    <div className="font-sans">
      <header className="fixed left-0 top-0 z-50 w-full  bg-white shadow-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between overflow-x-auto  p-1.5 px-6">
          <a href="/">
            <div className=" w-40 py-2">
              <img src="/VISA WORLD NEW.jpg" />
            </div>
          </a>
          <nav>
            <ul className="flex space-x-2 px-10 ">
              {["home", "about", "countries", "Testimonials", "contact"].map(
                (section) => (
                  <li key={section}>
                    <button
                      onClick={() => scrollToSection(section)}
                      className={`px-3 py-2 font-medium capitalize ${
                        activeSection === section
                          ? "border-b-2 border-blue-500 text-blue-500"
                          : "text-gray-700"
                      }`}
                    >
                      {section}
                    </button>
                  </li>
                ),
              )}
            </ul>
          </nav>
        </div>
      </header>

      <main className="mt-10">
        <section id="home" className="text-center">
          <div className="relative flex flex-col items-center justify-center lg:flex-row xl:flex-row">
            <div className="flex w-full flex-col items-center py-16 text-[#011473] lg:w-1/2 xl:w-1/2">
              <div className="  ">
                <p className="w-full text-4xl font-semibold text-[#011473]">
                  Visa World <br></br> Your Trusted Partner Your Journey to
                  Success Starts Here!
                </p>
                {/* <p className="text-xl  text-[#2E2E2E] mt-4">Talk to our team now to understand <br></br>how RBKPay can help</p> */}
              </div>
            </div>

            {/* Image on left */}
          </div>
        </section>

        <Contacts />

        <section id="about" className=" 2xl:px-20  text-black ">
          <div className="2xl:justify-center flex w-full flex-col items-center space-y-5 px-16 py-5 lg:h-screen lg:flex-row lg:space-x-5 lg:space-y-0 xl:h-screen xl:flex-row">
            {/* Image Section */}
            <div className="flex justify-center lg:w-1/2 xl:w-1/2">
              <img
                src="/images.png"
                alt="About Us Background"
                className="rounded-3xl object-cover lg:h-full lg:w-full xl:h-full xl:w-[550px]"
              />
            </div>

            {/* Text Section */}
            <div className="lg:w-1/2 xl:w-1/2">
              <h1
                data-aos="fade-up"
                className="font-inter mb-4 text-3xl font-semibold md:text-4xl lg:text-7xl xl:text-7xl"
              >
                About <strong className="text-white">Us</strong>
              </h1>
              <p
                data-aos="fade-up"
                className="font-inter leading-relaxed lg:text-lg xl:text-lg"
              >
                Since 2014, Visa World has expanded its presence globally. Our
                dedicated team collaborates with clients to deliver tailored
                solutions that address their immigration requirements. We strive
                to ensure a seamless and successful immigration experience.
              </p>

              <p
                data-aos="fade-up"
                className="font-inter m-2  leading-relaxed lg:text-md xl:text-md"
              >
                <a className="text-xl font-bold text-[#011473]">
                  What is Immigration?
                </a>
                <ul className="list-inside list-disc">
                  <a>
                    Immigration involves moving to another country to explore
                    new opportunities, such as advancing your career, pursuing
                    education, or reuniting with family. While it opens the door
                    to exciting possibilities, the process can be intricate and
                    challenging. At Visa World, we provide expert guidance to
                    help you navigate the complexities and achieve your
                    immigration aspirations smoothly.
                  </a>
                </ul>
              </p>
            </div>
          </div>
        </section>

        <section
          id="countries"
          className="bg-[#FFFFFF] p-2  text-center lg:p-8 xl:p-8"
        >
          <h2 className="font-arimo mb-4 mt-10 text-2xl font-bold text-[#333B69] md:text-4xl lg:text-5xl xl:text-5xl ">
            Our Countries
          </h2>

          <div className="lg:p-8 lg:px-10 xl:p-8 xl:px-10">
            <div className="grid grid-cols-1 gap-8 text-start md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
              {[
                {
                  title: "Canada",
                  description:
                    "Discover the vast beauty and opportunities of Canada, a nation known for its high quality of life, diversity and natural landscapes. ",
                  link: "/ ",
                },
                {
                  title: "Australia",
                  description:
                    "Australia offers a laid-back lifestyle with world-class beaches, stunning natural wonders and robust job prospects",
                  link: "/ ",
                },
                {
                  title: "USA",
                  description:
                    "The USA is a land of diverse cultures, bustling cities, and boundless opportunities for personal and professional growth.  ",
                  link: "/ ",
                },
                {
                  title: "UK",
                  description:
                    "The United Kingdom offers a rich history, thriving job market and multicultural environment. ",
                  link: "/ ",
                },
                {
                  title: "Denmark",
                  description:
                    "Denmark is known for its high standard of living, environmental consciousness and innovative industries. ",
                  link: "/ ",
                },
                {
                  title: "New Zealand ",
                  description:
                    "New Zealand is a paradise for nature lovers and outdoor enthusiasts, with a thriving economy and welcoming locals.",
                  link: "/ ",
                },
              ].map((box, index) => (
                <div
                  key={index}
                  className="font-arimo flex flex-col justify-between rounded-3xl border-2 border-black p-6 lg:h-60 lg:w-full xl:h-60 xl:w-full"
                >
                  <div>
                    <h3 className="mb-3 text-xl font-bold">{box.title}</h3>
                    <p className="text-base">{box.description}</p>
                  </div>
                  <a
                    href={box.link}
                    className="text-black-600 text-lg font-bold hover:text-[#FF8064]"
                  >
                    Learn more →
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* <section
          id="Testimonials"
          className="bg-white py-10 text-center lg:py-24 xl:py-24"
        ><h2 className="font-inter text-2xl font-semibold text-[#0F0F27] md:text-4xl lg:text-5xl xl:text-6xl xl:mb-8 flex items-center justify-center">
        Clients are always
        <a className="px-2 font-bold text-[#FF8064] md:px-3 lg:px-4"> Satisfied </a> With Us
      </h2>
      
      

          <div
            className="relative mx-auto w-full items-center justify-center p-4 px-10 pt-4 text-blue-950 lg:px-40 xl:px-40"
            onMouseEnter={() => sliderRef.current.slickPause()}
            onMouseLeave={() => sliderRef.current.slickPlay()}
          >
            <Slider ref={sliderRef} {...settings}>
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center text-center "
                >
                  <img
                    src={testimonial.image}
                    alt={testimonial.title}
                    className=" mx-auto w-[50%] md:w-[18%] lg:w-[20%]  xl:w-[20%]"
                    style={{
                      aspectRatio: "3 / 2",
                      objectFit: "contain",
                    }}
                  />
                  <div className="lg:w-max-w-full max-w-72 md:ml-36 md:max-w-2xl xl:max-w-full">
                    <p className="font-inter mt-4 text-lg">
                      {testimonial.text}
                    </p>
                  </div>
                  <h3 className="font-inter mt-4 text-lg font-semibold  text-blue-900">
                    {testimonial.author}
                  </h3>
                  <h3 className="font-inter mb-3 text-lg  font-semibold text-[#FF8064]">
                    {testimonial.title}
                  </h3>
                </div>
              ))}
            </Slider>
          </div>
        </section> */}

        <section id="contact" className="  bg-white text-center ">
          <h1 className="font-inter text-2xl font-semibold text-[#0F0F27] lg:text-5xl xl:text-5xl">
            {" "}
            Contact Us{" "}
          </h1>
          <div className="static flex justify-center px-2 py-10 lg:px-0 lg:py-20 xl:px-0 xl:py-20">
            <div className="font-inter  flex flex-col items-center space-y-2 rounded-bl-[90px] rounded-tr-[90px] border-2 border-black p-10 text-sm text-slate-700 lg:text-[18px]  xl:text-[18px] ">
              <div className="md:flex md:space-x-10 lg:flex lg:space-x-32 xl:flex xl:space-x-32 ">
                <div className="flex flex-col space-y-4">
                  <a
                    href="https://www.google.com/maps?q=Level+7-1+Menara+Rajawali,+Jl.+DR+Anak+Agung+Gde+Agung,+Lot+5.1,+Mega+Kuningan,+Jakarta+Selatan,+Indonesia,+12950"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    <li className="flex  items-center text-start">
                      <IoLocationSharp className="mr-5 h-8 w-8 text-blue-500" />
                      UAE Branch #1414, Tamani Arts Office,
                      <br></br> Business Bay, Dubai, United Arab Emirates.
                    </li>{" "}
                  </a>

                  <li className="flex items-center">
                    <CgProfile className="mr-5 h-8 w-8 text-blue-500" />
                    +971 50 287 0799
                  </li>
                </div>

                <div className="flex flex-col  space-y-4">
                  <a
                    href="https://www.google.com/maps/search/RBK+Consultancy+Services+LLC+244+5th+Ave,+Suite+%23+R235,+New+York,+NY+10001,+United+States/@40.7050262,-74.0656444,12z/data=!3m1!4b1?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    <li className="flex  items-center text-start ">
                      <IoLocationSharp className="mr-5 h-8 w-8 text-blue-500" />
                      RBK Consultancy Services LLC 244 5th Ave, Suite # R235
                      <br></br>New York, NY 10001, United States
                    </li>
                  </a>

                  <li className="flex items-center">
                    <CgProfile className="mr-5 h-8 w-8 text-blue-500" />
                    +1 (929) 309-1457
                  </li>
                </div>
              </div>

              <a href="mailto:info@visaworlds.net" className="hover:underline">
                <li className="mt-4 flex items-center">
                  <CgMail className="h-8 w-8 text-blue-500 lg:mr-5 xl:mr-5" />
                  info@visaworlds.net
                </li>
              </a>
            </div>
          </div>

          <div className="  h-96 bg-white bg-gradient-to-br">
            <div className="flex justify-evenly ">
              <div className="py-9">
                <img
                  src="/VISA WORLD NEW.jpg"
                  alt="Logo"
                  className="mb-10 h-8 lg:h-10 xl:h-10"
                />

                <ui className="list-none space-y-2 text-start text-black">
                  <a href="/about">
                    {" "}
                    <li> About Us </li>{" "}
                  </a>
                  <hr className="border-dotted border-black pb-2" />
                  <a href="/contact">
                    {" "}
                    <li> Contact Us </li>{" "}
                  </a>
                  <hr className="border-dotted border-black pb-2" />
                  {/* <a href="/use-case">
                    {" "}
                    <li> Use Case</li>{" "}
                  </a>
                  <hr className="border-dotted border-black pb-2" /> */}
                  <a href="/privacypolicy">
                    {" "}
                    <li> Privacy Policy </li>{" "}
                  </a>
                  <hr className="border-dotted border-black pb-2" />
                  <a href="/termservices">
                    {" "}
                    <li> Terms and Conditions </li>{" "}
                  </a>
                  <hr className="border-dotted border-black " />
                </ui>
              </div>

              <div className=" mt-28 space-y-4">
                <li className="flex items-center text-black">
                  <CgProfile className="mr-2 h-8 w-8 text-black" />
                  +971 50 287 0799
                </li>
                <hr className="my-6 border-dotted border-black" />
                <a
                  href="mailto:info@visaworld.net"
                  className="text-black hover:underline"
                >
                  <li className="mt-4 flex items-center">
                    <CgMail className="mr-2 h-8 w-8" />
                    info@visaworld.net
                  </li>
                  <hr className="my-4 border-dotted border-black" />
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Visaworldlandingpage;
